import type { Router } from 'vue-router'

import { useSystemMenuStore } from '@admin/store/modules/systemMenu'
import { useHandleIframe } from '@admin/views/common/iframe/hooks/useHandleIframe'
import { PageEnum } from '@admin/enums/pageEnum'
import { decodeByBase64 } from 'framework/utils/cipher'

// export function createBiJumpGuard(router: Router) {
//   router.beforeEach(async (to, from, next) => {
//     const systemMenuStore = useSystemMenuStore()
//     const { conversionUrl } = useHandleIframe()
//     if (to.path.indexOf('bi/page') > -1 || to.path.indexOf('bi-code/') > -1) {
//       const findMenu = systemMenuStore.allMenuList.find((v) => v.path === to.path)
//       if (findMenu) {
//         const iframeUrl = conversionUrl(findMenu)
//         next(iframeUrl.path)
//       } else {
//         next(PageEnum.ERROR_PAGE)
//       }
//     }
//     next()
//   })
// }

export function createBiJumpGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    const systemMenuStore = useSystemMenuStore()
    const { conversionUrl } = useHandleIframe()
    const { name, query } = to
    if (name === 'iframe') {
      // 这里检验不是很全，主要是在bi系统中，编辑查看，iframe地址都会变化，而这些是没有记录在菜单列表中的
      // 1、先用真实的url 从菜单列表里面寻找出菜单， 存在next()
      // 2、如果找不到，则用menuId 去找菜单列表找出对应的菜单，存在next()，不存在404
      // 3、能打开，后续权限校验依靠数据做权限验证
      const realUrl = decodeByBase64(decodeURIComponent(query.url) as string)
      if (realUrl.indexOf('bi-cube') > -1) {
        const findMenu = systemMenuStore.allMenuList.find(
          (v) => v.iframe_url === realUrl && !v.hidden,
        )
        if (findMenu && findMenu?.id) {
          next()
        } else {
          const findMenuId = systemMenuStore.allMenuList.find(
            (ele) => `${ele.id}` === `${query.menuId}`,
          )
          if (findMenuId) {
            next()
          } else {
            next(PageEnum.ERROR_PAGE)
          }
        }
      } else {
        next()
      }
    } else {
      if (to.path.indexOf('bi/page') > -1 || to.path.indexOf('bi-code/') > -1) {
        const findMenu = systemMenuStore.allMenuList.find((v) => v.path === to.path)
        if (findMenu) {
          const iframeUrl = conversionUrl(findMenu)
          next(iframeUrl.path)
        } else {
          next(PageEnum.ERROR_PAGE)
        }
      } else {
        next()
      }
    }
  })
}
